import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';
import { EmailAcknowledgementApi } from '../../api/email-acknowledgement.api';
import { GetEmailAcknowledgeStatus, SubmitEmailAcknowledge } from './email-acknowledgement.state-actions';

export interface EmailAcknowledgementStateModel {
  status: 'FRESH' | 'ALREADY_ACKNOWLEDGED' | 'EXPIRED' | 'DELIVERY_FAILED' | null;
  acknowledgeName?: string;
  acknowledgeTimestamp?: string;
  recipientEmail?: string;
  redirectUrl?: string;
  hasCustomLandingPage?: boolean;
}

@State<EmailAcknowledgementStateModel>({
  name: 'email_acknowledgement',
  defaults: { status: null },
})
@Injectable()
export class EmailAcknowledgementState {
  constructor(private emailAcknowledgementApi: EmailAcknowledgementApi) {}

  @Selector()
  static current(state: EmailAcknowledgementStateModel) {
    return state;
  }

  @Action(GetEmailAcknowledgeStatus)
  getStatus(context: StateContext<EmailAcknowledgementStateModel>, { token }: GetEmailAcknowledgeStatus) {
    return this.emailAcknowledgementApi.getStatus(token).pipe(
      tap((response) => {
        context.patchState({
          status: response.data.status,
          acknowledgeName: response.data.acknowledgeName,
          acknowledgeTimestamp: response.data.acknowledgeTimestamp,
          recipientEmail: response.data.recipientEmail,
          redirectUrl: response.data.redirectUrl,
          hasCustomLandingPage: response.data.hasCustomLandingPage,
        });
      })
    );
  }

  @Action(SubmitEmailAcknowledge)
  submit(context: StateContext<EmailAcknowledgementStateModel>, { token }: SubmitEmailAcknowledge) {
    return this.emailAcknowledgementApi.acknowledge({ token }).pipe(
      tap((response) => {
        context.patchState({
          status: response.data.status,
          acknowledgeName: response.data.acknowledgeName,
          acknowledgeTimestamp: response.data.acknowledgeTimestamp,
          recipientEmail: response.data.recipientEmail,
          redirectUrl: response.data.redirectUrl,
        });
      })
    );
  }
}
